export default {
  GroupEmailerSendPreview: {
    mounted() {
      const button = this.el.querySelector("button#send-preview-button");
      const input = this.el.querySelector("div > #send-preview-emails-input");

      // Enable button if input value is more than 6 characters and contains an "@" symbol
      input.addEventListener("input", () => {
        if (input.value.length >= 6 && input.value.includes("@")) {
          button.disabled = false;
        } else {
          button.disabled = true;
        }
      });

      button.addEventListener("click", () => {
        const emails = input.value;

        // Validate contents of input
        if (input.value.length < 6 || !input.value.includes("@")) {
          return;
        }

        // Dispatch event to server
        this.pushEventTo(this.el, "send-preview", { emails });

        // Disable button for 2 seconds after click to prevent spamming
        setTimeout(() => {
          button.disabled = false;
        }, 2000);
      });
    },
  },
};
